import { pick } from 'lodash'
import { useContext } from 'react'
import { PersistentLayoutContext } from '@core/providers/PersistentLayoutContext'
import { AdminPageMounted } from '@core/providers/AdminPageLoad'

const withLayout =
  ({ layout: Layout }) =>
  (PageComponent) => {
    return function PageLayout(props) {
      const workspaceLayout = useContext(PersistentLayoutContext)
      if (Layout && workspaceLayout === Layout) {
        return (
          <AdminPageMounted>
            <PageComponent {...props} />
          </AdminPageMounted>
        )
      }
      return Layout ? (
        <Layout
          {...pick(props, [
            'location',
            'history',
            'match',
            'userData',
            'permission'
          ])}
        >
          <PageComponent {...props} />
        </Layout>
      ) : (
        <PageComponent {...props} />
      )
    }
  }

export default withLayout
